import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setDocuments, setGetDocumentError, setLoading } from "../../repository/slice";

function* getDocumentsWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/document/get-list", payload);
        if (isError) {
            yield put(setGetDocumentError(message));
        } else {
            yield put(setGetDocumentError(null));
            yield put(setDocuments({documents: data.rows, count: data.count}));
        }
    } catch (error) {
        console.error("getDocumentsWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getDocumentsWatcher() {
    yield takeLatest("@saga/GET_DOCUMENTS", getDocumentsWorker);
};
